import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../api/api.service';
import { LOCATIONS_ENDPOINTS } from '../../api/endpoints/locations.endpoints';
import { City, District, Region } from '../../../shared/Models/locations.model';

@Injectable({
  providedIn: 'root',
})
export class LocationsService {
  private api = inject(ApiService);

  getCountries(): Observable<any> {
    return this.api.get<any>(LOCATIONS_ENDPOINTS.V1.ADDRESS_LOCATIONS);
  }

  getRegionsByCountryPK(country_pk: number): Observable<Region[]> {
    return this.api.get<Region[]>(LOCATIONS_ENDPOINTS.V1.REGIONS(country_pk));
  }

  getCitiesByRegionPK(region_pk: number): Observable<City[]> {
    return this.api.get<City[]>(LOCATIONS_ENDPOINTS.V1.CITIES(region_pk));
  }

  getCoveredCities(params?: any): Observable<City[]> {
    if (params) {
      return this.api.get<City[]>(LOCATIONS_ENDPOINTS.V1.ALL_CITIES, {
        params: { region_id: params },
      });
    } else {
      return this.api.get<City[]>(LOCATIONS_ENDPOINTS.V1.ALL_CITIES);
    }
  }

  getAllRegions(): Observable<Region[]> {
    return this.api.get<Region[]>(LOCATIONS_ENDPOINTS.V1.ALL_REGIONS);
  }

  getDistrictsByCityPK(city_pk: number): Observable<District[]> {
    return this.api.get<District[]>(LOCATIONS_ENDPOINTS.V1.DISTRICTS(city_pk));
  }

}
